export default __webpack_public_path__ + "static/media/paspor benar.7e6864f3.jpg";